{
  "version": "0.0.0",
  "id": "at.softline.lagerhaus.gleinstaetten.softline",
  "name": "Softline"
}
